import { API } from '../../api';
import { axiosInstance } from '../../axios';
import { PopularTypes } from '@/shared/api/popular/getPopular/types';
import { IImage } from '@/shared/api/types/image';

interface IParams {
  category_id?: number;
  limit?: number;
  paged?: number;
  type: PopularTypes;
  lang: string;
}

export const getPopular = async ({
  category_id,
  type,
  limit = 9,
  paged = 1,
  lang,
}: IParams) => {
  const lib = {
    [PopularTypes.month]: API.getPopularByMonth,
    [PopularTypes.week]: API.getPopularByWeek,
    [PopularTypes.all]: API.getPopular,
  };

  const result = await axiosInstance.get<IResponse>(lib[type], {
    params: {
      category_id,
      limit,
      paged,
      return_ids: false,
      lang,
    },
  });

  return result.data;
};

interface IResponse {
  photos: IImage[];
  photosIds: string[];
}
